/**
 * 营运中心--》开单记录
 */

export default {
  // 开单记录支持整行复制 202511111051052507006
  copy_with_units: ['99563']
}
